import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CmsPage } from 'src/app/models/cms-page';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CmsPageService {

 


  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + '/' + 'api/cms/page';

  searchCmsPage(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  getCmsPage(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  postCmsPage(page: CmsPage): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, page)
  }

  getPageById(pageId: number): Observable<Object> {
    return this.http.get(`${this.url}/${pageId}`);
  }

  syncCmsPageData() {
    return this.http.get(`${this.url}/sync`);
  }

  getAllCmsDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getAllCmsDropDownByAccount(accountName): Observable<Object> {
    return this.http.get(`${this.url}/list/dropdown/${accountName}`);
  }

  titleVerified(title: any): Observable<Object> {
    return this.http.get(`${this.url}/title/${title}`);
  }

  getAllCmsDropDownNew(): Observable<Object> {
    return this.http.get(`${this.url}/layout/dropdown`);
  }

}
